export default __webpack_public_path__ + "static/Search-88c09689cc777b13641c7f4b2a4b761d.svg";